// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { ResponseMessageSchema, StatusSchema } from "./utilitySchemas";

const MetricsDataSchema = z.object({
	pendingUserAccountRequests: z.number().int().nonnegative(),
});

export type MetricsData = z.infer<typeof MetricsDataSchema>;

export const MetricsDataSchemaResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: MetricsDataSchema,
});
export type MetricsDataResponse = z.infer<typeof MetricsDataSchemaResponseSchema>;


const RequestsOutOfSyncWithNinoxSchema = z.object({
    id: z.string(),
    isTemp: z.boolean(),
    evalionId: z.string().nullable(),
    requiresNinoxSync: z.boolean(),
    lastNinoxSync: z.string().nullable(),
    type: z.string(),
});

export type RequestsOutOfSyncWithNinox = z.infer<typeof RequestsOutOfSyncWithNinoxSchema>;

export const RequestsOutOfSyncWithNinoxResponseSchema = z.object({
  status: StatusSchema,
  message: ResponseMessageSchema,
  data: RequestsOutOfSyncWithNinoxSchema.array(),
});
export type RequestsOutOfSyncWithNinoxResponse = z.infer<typeof RequestsOutOfSyncWithNinoxResponseSchema>;